var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Batteries',{attrs:{"no-filter":"","tab":"","query":{ projectId: _vm.project.id }}})
}
var staticRenderFns = []

export { render, staticRenderFns }